export default {"src":"/_next/static/media/residential11.40cd37cd.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};